import React from 'react';
import { Outlet } from 'react-router-dom';
import PrimaryNav from '../primary/PrimaryNav';
import PrimaryBottomNav from '../primary/PrimaryBottomNav';

function PrimaryschoolLayout() {
  return (
    <>
      <PrimaryNav />
      <Outlet />   {/* Nested pages render here */}
      <PrimaryBottomNav />
    </>
  );
}

export default PrimaryschoolLayout;

